export default class PhoneNumber {
  constructor() {
    'ngInject';

    this.require = 'ngModel';
    this.restrict = 'A';
  }

  link($scope, element, attrs, ctrl) {
    ctrl.$validators.phoneNumber = (modelValue) => {
      if (!(modelValue && modelValue.length)) {
        return true;
      }

      const pattern = /^\(?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/;
      return modelValue.match(pattern);
    };
  }

  static directiveFactory() {
    'ngInject';

    return new PhoneNumber();
  }
}



// WEBPACK FOOTER //
// ./common/directives/validation/phone-number.js